module.exports = __webpack_public_path__ + "img/logo_mini.ad09cf5b.svg";